import t from "lib/i18n";
import useModal from "hooks/useModal";
import useConfig from "hooks/useConfig";

import Button, { ButtonColors } from 'components/ui/Button';

import "styles/components/flexi/flexi-help-modal.scss";

const FlexiHelpModal = () => {
  const { brand } = useConfig();
  const infoUrlKey = `flexi.infoLink.${brand}`;

  const { closeModal } = useModal();

  const baseClass = 'otrl-jp__flexi-help-modal';

  return (
    <div className={baseClass}>
        <h2 className={`${baseClass}-title`}>
          {t('flexi.modal.heading')}
        </h2>
      <div className={`${baseClass}-body`}>
        <p>{t('flexi.modal.bodyCopy1')}</p>
        <p>{t('flexi.modal.bodyCopy2')}</p>
        <p>{t('flexi.modal.bodyCopy3')}</p>
        <p>{t('flexi.modal.bodyCopy4')}</p>
        <p>
          {t('flexi.modal.bodyCopy5')}
          {brand && <span>&nbsp;<a aria-label="Learn more about Flexi Season tickets" rel="noreferrer" target="_blank" href={t(infoUrlKey)}>{t('flexi.modal.moreInfo')}</a></span>}
        </p>
      </div>
      <div className={`${baseClass}-actions`}>
        <Button
          color={ButtonColors.SECONDARY}
          onClick={closeModal}
        >
          {t('flexi.modal.close')}
        </Button>
      </div>
    </div>
  );
};

export default FlexiHelpModal;
